'use client'

import { paths } from '@/config/paths'
import { LinkButton } from '@/ui/atoms/button/Button'
import { ArrowLeft } from 'lucide-react'
import { useSearchParams } from 'next/navigation'

export const FROM_SOURCES: Record<string, { href: string; label: string }> = {
  earn: { href: paths.earn, label: 'Back to Earn' },
  pooled: { href: `${paths.earn}?open=pooled`, label: 'Back to Pooled' },
  prime: { href: `${paths.earn}?open=prime`, label: 'Back to Prime' },
  yield: { href: `${paths.earn}?open=yield`, label: 'Back to Yield' },
  scale: { href: `${paths.earn}?open=scale`, label: 'Back to Scale' },
  isolated: { href: `${paths.earn}?open=legacy`, label: 'Back to Legacy' },
}

interface BackNavProps {
  defaultHref: string
  defaultLabel: string
  className?: string
}

export function BackNav({ defaultHref, defaultLabel, className }: BackNavProps) {
  const searchParams = useSearchParams()
  const from = searchParams.get('from')

  const sourceConfig = from ? FROM_SOURCES[from] : null
  const href = sourceConfig?.href ?? defaultHref
  const label = sourceConfig?.label ?? defaultLabel

  return (
    <div className={className ?? 'flex items-center gap-1 px-3 lg:px-0'}>
      <LinkButton href={href} variant="text" size="sm" spaceAround="none" prefixIcon={<ArrowLeft size={16} />}>
        {label}
      </LinkButton>
    </div>
  )
}
